(function($) {

    function isInViewport(element) {
        if(element){
            const rect = element.getBoundingClientRect();
            return (
                rect.top > window.innerHeight - 50 ||
                rect.bottom < 50
            );
        }
    }

    if( $('.sidebar-timeline').length ){
        function scrollAlong(){
            var scrollMiddle = $(window).scrollTop() + ($(window).height() / 2);

            $('.sidebar-timeline .nav-wrapper').each(function(){
                var parentTop = $(this).parent().offset().top;
                var parentBottom = $(this).parent().height() - $(this).height();
                var thisMiddle = scrollMiddle - parentTop - ($(this).height() / 2);

                var parentOffsetBottom = $(this).parent().height() + $(this).parent().offset().top - ($(this).outerHeight() / 2);

                var thePosition = 'fixed';
                var theTop = $(window).height() / 2 - ($(this).height() / 2);

                if(thisMiddle < 0){
                    theTop = 0;
                    thePosition = 'static';
                }


                if(scrollMiddle > parentOffsetBottom - 50){
                    theTop = parentBottom - 50;
                    thePosition = 'absolute';
                }

                $(this).css({position: thePosition, top: theTop});
            });
        }


        //Make side nav sticky to the scroll
        $(window).on('load scroll resize', function(){
            if($('.sidebar-timeline .nav-wrapper').outerHeight() == $('.sidebar').outerHeight()){

            } else{

                if(!$('.sidebar-timeline').length ) {
                    return;
                }
                if(window.innerWidth < 767){
                    $('.sidebar-timeline').css({position: '', top: ''});
                    return;
                }

                var inView = false;
                $('.full-width-section, footer').each(function(){
                    if( isInViewport( this ) == false ){
                        inView = true;
                    }
                });

                if(inView == true){
                    $('.nav-wrapper').fadeOut();
                } else {
                    $('.nav-wrapper').fadeIn();
                }

                scrollAlong();
            }

        });
    }


    $(document).ready(function() {
        $(".dot").on("click", function(event) {
            event.preventDefault(); // Prevent default anchor behavior

            const targetId = $(this).data("scrollto");
            const targetSection = $("#" + targetId);

            if (targetSection.length) {
                $("html, body").animate({
                    scrollTop: targetSection.offset().top
                }, 800); // Adjust duration (800ms) for smooth scroll
            }
        });

        $(".down").on("click", function(event) {
            event.preventDefault();
            $("html, body").animate({
                scrollTop: $(window).scrollTop() + 800
            }, 300);
        });

        // Scroll up on click of the up arrow
        $(".up").on("click", function(event) {
            event.preventDefault();
            $("html, body").animate({
                scrollTop: $(window).scrollTop() - 800
            }, 300);
        });
    });



    document.addEventListener("DOMContentLoaded", () => {

        const years = document.querySelectorAll(".year");

        console.log(years);

        const options = {
            root: null,
            threshold: 0.7
        };

        const observerCallback = (entries) => {
            entries.forEach(entry => {
                const year = entry.target.dataset.year;
                const century = entry.target.closest(".century").id.split("-")[1];

                if (entry.isIntersecting) {
                    // Entry is intersecting the viewport
                    console.log(`Entering view: Year ${year}, Century ${century}`);
                    updateActiveDots(century, year);
                } else if (entry.boundingClientRect.top > 0) {
                    // Entry is exiting at the top (scrolling up)
                    console.log(`Exiting at top: Year ${year}, Century ${century}`);
                    updateActiveDots(century, year);
                }
            });
        };

        const observer = new IntersectionObserver(observerCallback, options);

        years.forEach(year => observer.observe(year));

        function updateActiveDots(century, year) {
            console.log('Updating the dot');
            const dots = document.querySelectorAll(".nav .dots .dot");

            dots.forEach(dot => {
                if (dot.dataset.century === century) {
                    dot.classList.add("active");
                    dot.textContent = year;
                } else {
                    dot.classList.remove("active");
                    // dot.textContent = "";
                }
            });
        }

    });
})(jQuery);
